import { render } from "./ErrorPage.vue?vue&type=template&id=535c38f4"
import script from "./ErrorPage.vue?vue&type=script&lang=js"
export * from "./ErrorPage.vue?vue&type=script&lang=js"

import "./ErrorPage.vue?vue&type=style&index=0&id=535c38f4&lang=css"
script.render = render

export default script